export interface socialCheckCrudResponse {
  message: string
  status: number
  info: SocialCheckItem[]
}

export enum EReportType {
  SelfCheck = 'self_check',
  ImpersonationCheck = 'impersonation_check',
}

export enum ESocialCheckStatus {
  None = 'None',
  NotReleased = 'NotReleased',
  InQueue = 'InQueue',
  InProgress = 'InProgress',
  Complete = 'Complete',
  Error = 'Error',
  PendingDownloadPdf = 'PendingDownloadPdf',
  PendingReview = 'PendingReview',
  ErroPdf = 'ErrorPdf',
  Cancelled = 'Cancelled',
}

export type SocialCheckResponse = SocialCheckItemWrapper[]

export interface SocialCheckItem {
  status: string
  pdf: string
  requester: {
    firstname: string
    lastname: string
    email: string
  }
  reportType: EReportType
  lastUpdate: string
  inputs: SocialCheckInputItem
  reportDate: string
  pdfViewed: boolean
  id: string
  enterprise: {
    id: string
    name: string
    credits: number
  }
  complianceSigned: string
  disclosureSigned: string
  summarySigned: string
  dynamicSigned: string
  otherAuthorizationSigned: string
}

export interface SocialCheckItemWrapper {
  type: 'socialCheck'
  creation_date: string
  data: SocialCheckItem
}

export interface SocialCheckInputItem {
  name: string
  nickname: string
  city: string
  state: string
  country: string
  email: string
  highSchool: string
  college: string
  phone: string
  twitterUrl: string
  facebookUrl: string
  instagramUrl: string
  linkedInUrl: string
  tikTokUrl: string
  ageOrDateOfBirth: string
}

export interface UpdateEnterpriseData {
  enterpriseId: string
  companyName: string | undefined
  companyAddress: string | undefined
}

export enum EEnterpriseRole {
  OWNER = 'owner',
  READER = 'reader',
}

export interface IDeletedHistoryItem {
  subjectFullName: string
  originalCompletedAt: Date
  deletedAt: Date
  deletionReason: string
  subjectInputs: any
  socialMedias: any[]
  digitalFootprints: any[]
}

export interface IDeletedHistoryResponse {
  message: string
  status: number
  info: IDeletedHistoryItem[]
}
